export interface IMedicalCardTemplateDto {
  type: MedicalCardTemplateTypes;
  title: string;
  code?: string;
  text?: string;
  description?: string;
}

export type MedicalCardTemplateTypes =
  | "TYPE_OF_CONSULTATION"
  | "MEDICAL_HISTORY"
  | "MANIFESTATION"
  | "IMAGING_TEST"
  | "ICD_10"
  | "ICD_9"
  | "QUALIFICATION"
  | "RECOMMENDED";

export enum MedicalCardTemplateTypesEnum {
  TYPE_OF_CONSULTATION = "TYPE_OF_CONSULTATION",
  MEDICAL_HISTORY = "MEDICAL_HISTORY",
  MANIFESTATION = "MANIFESTATION",
  IMAGING_TEST = "IMAGING_TEST",
  ICD_10 = "ICD_10",
  ICD_9 = "ICD_9",
  QUALIFICATION = "QUALIFICATION",
  RECOMMENDED = "RECOMMENDED",
}

export const medicalCardTemplateTypeLabels: Record<
  MedicalCardTemplateTypes,
  string
> = {
  TYPE_OF_CONSULTATION: "consultationType",
  MEDICAL_HISTORY: "medicalHistory",
  MANIFESTATION: "manifestation",
  IMAGING_TEST: "imagingTests",
  ICD_10: "icd10",
  ICD_9: "icd9",
  QUALIFICATION: "qualification",
  RECOMMENDED: "recommended",
};
